'use strict';

const { createReducerStore } = require('fluxible-reducer-store');
const Message = require('bunsen/models/usercomm/Message');
const ContactDealerStore = createReducerStore(require('../stores/ContactDealerStore'));
const authModalLoader = require('dibs-buyer-layout/src/utils/AuthModalLoader').default;

const ENTER_MESSAGE = 'ENTER_MESSAGE';
const ENTER_NAME = 'ENTER_NAME';
const MESSAGE_SEND_BEGIN = 'MESSAGE_SEND_BEGIN';
const MESSAGE_SEND_END = 'MESSAGE_SEND_END';
const SET_USER_VALUES = 'SET_USER_VALUES';
const SET_OPTIMIZELY_VARIANT = 'SET_OPTIMIZELY_VARIANT';

function setOptimizelyVariant(actionContext, payload) {
    actionContext.dispatch(SET_OPTIMIZELY_VARIANT, payload);
}

function initializeOffer(actionContext, payload) {
    actionContext.dispatch('pdp:contact:loading:done', payload);
}

function submitOffer(actionContext, payload) {
    const { item, offer } = payload;
    const message = actionContext.getStore(ContactDealerStore).getMessage();
    offer.redirectToCheckout({ message, item });
}

function sendMessageBegin(actionContext) {
    actionContext.dispatch(MESSAGE_SEND_BEGIN);
}

function sendMessageEnd(actionContext) {
    actionContext.dispatch(MESSAGE_SEND_END);
}

function sendMessage(actionContext, payload) {
    const { messageBody } = payload;
    const message = new Message(messageBody, {setMilestones: false});
    if (messageBody.textBody) {
        sendMessageBegin(actionContext);
        return message.save().then(() => sendMessageEnd(actionContext));
    }
    return null;
}

function enterName(actionContext, payload) {
    actionContext.dispatch(ENTER_NAME, payload);
}

function enterMessage(actionContext, payload) {
    actionContext.dispatch(ENTER_MESSAGE, payload);
}

function submitMessageLoggedIn(actionContext, payload) {
    actionContext.dispatch(SET_USER_VALUES, {
        displayName: actionContext.getStore(ContactDealerStore).getName(),
        user: payload,
    });
    const messageBody = actionContext.getStore(ContactDealerStore).state;
    return sendMessage(actionContext, messageBody);
}

function submitMessageNotLoggedIn(actionContext) {
    const action = authModalLoader.constants.REGISTER;

    authModalLoader
        .show({
            action,
            flow: authModalLoader.constants.CONTACT_DEALER_FORM_FLOW,
            ga: { label: 'contact link in pdp – more from dealer module' },
        })
        .then(({ err, user }) => {
            if (!err && user && !actionContext.getStore(ContactDealerStore).getMessageSent()) {
                submitMessageLoggedIn(actionContext, user);
            }
        });
}

module.exports = {
    initializeOffer,
    setOptimizelyVariant,
    enterName,
    enterMessage,
    submitMessageLoggedIn,
    submitMessageNotLoggedIn,
    submitOffer,
    sendMessageBegin,
    sendMessageEnd,
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/actions/contactDealerActions.es.js